import collectedOptions from '../config/collectedOptions';
import { getStore } from '../store/store';
import { computed, IComputedValue } from 'mobx';
import { OptionCategory } from 'owa-options-core';

let currentCategory = computed<OptionCategory>(() => {
    for (let categoryIndex = 0; categoryIndex < collectedOptions().length; categoryIndex++) {
        let currentCategory = collectedOptions()[categoryIndex];

        if (currentCategory.key == getStore().currentCategoryKey) {
            return currentCategory;
        }
    }

    return null;
}) as IComputedValue<OptionCategory>;

export default () => currentCategory.get();
